import type { RootState } from '/business/shared/state/store';
import { EMPTY_ARRAY } from '/business/shared/state/selectors/util';

export default (state: RootState) => state.basket?.questionAnswerStructured || EMPTY_ARRAY;
